import { useRouter } from 'next/router';
import { useCallback, useMemo } from 'react';
import {
  ISwitchGroupIconOption,
  ISwitchGroupProps,
  SwitchGroup,
} from '~/components/SwitchGroup';
import { VIEW_OPTIONS } from '~/constants';
import { SHARED_PAGE_URL_PREFIX } from '~/constants/urls';
import { VIEW_OPTIONS_ICON } from '~/screens/SearchContent/SearchContent.constants';

import { VIEW_TYPE, ViewType, useActiveView } from '../hooks/useActiveView';

interface Props
  extends Omit<ISwitchGroupProps, 'onChange' | 'options' | 'value'> {
  isMobile?: boolean;
  defaultValue?: ViewType;
  setActiveView?: (view: ViewType) => void;
}
interface SwitchOption extends ISwitchGroupIconOption {
  value: ViewType;
}

export const ToggleView: React.FC<Props> = ({
  isMobile,
  defaultValue,
  setActiveView,
  ...stackProps
}) => {
  const { activeView: activeViewPath, setActiveView: setActiveViewPath } =
    useActiveView();
  const router = useRouter();
  const isShared = router.pathname.includes(SHARED_PAGE_URL_PREFIX);

  const options: SwitchOption[] = useMemo(
    () => [
      {
        icon: VIEW_OPTIONS_ICON[VIEW_OPTIONS.grid],
        value: VIEW_TYPE.stacked,
        name: VIEW_TYPE.stacked,
        isDisabled: true,
      },
      {
        icon: VIEW_OPTIONS_ICON[VIEW_OPTIONS.card],
        isDefault: defaultValue === VIEW_TYPE['card'],
        value: VIEW_TYPE['card'],
        name: VIEW_TYPE['card'],
        isDisabled: false,
        dataHeapTrack: 'wm-talent-tab-gallery-view',
      },
      {
        icon: VIEW_OPTIONS_ICON[VIEW_OPTIONS.list],
        isDefault: !isShared || defaultValue === VIEW_TYPE.list,
        value: VIEW_TYPE.list,
        name: VIEW_TYPE.list,
        dataHeapTrack: 'wm-talent-tab-list-view',
      },
    ],
    [defaultValue, isShared],
  );

  const handleChange = useCallback(
    (view: ViewType) => {
      setActiveView ? setActiveView(view) : setActiveViewPath(view);
    },
    [setActiveViewPath, setActiveView],
  );

  if (isMobile) {
    return (
      <SwitchGroup
        name="Select View"
        value={setActiveView ? defaultValue : activeViewPath}
        options={options}
        onChange={handleChange}
        radioGroupProps={{
          width: '100%',
          justifyContent: 'center',
          marginBottom: '16px',
        }}
        radioButtonProps={{ width: '100%' }}
        {...stackProps}
      />
    );
  }

  return (
    <SwitchGroup
      name="Select View"
      value={setActiveView ? defaultValue : activeViewPath}
      options={options}
      onChange={handleChange}
      {...stackProps}
    />
  );
};
